import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateToastBubbleMessage } from './use-update-toast-bubble-message'

export const ToastBubbleMessage = memo(() => {
  useUpdateToastBubbleMessage()

  const bubbleMessages = useGlobalStore(
    useShallow((state) => {
      return state.bubbleMessages
    }),
  )

  if (!bubbleMessages?.length) {
    return null
  }

  return (
    <div className="w-screen h-screen flex justify-center flex-col gap-2 ">
      {bubbleMessages?.map(
        (toast, index) => index === 0 && <Toast key={toast.id} toast={toast} />,
      )}
    </div>
  )
})
